import React, {useEffect, useState}  from "react"
import useSelfCheckinNafigation from 'utils/useSelfCheckinNafigation';
import { useTranslation } from 'react-i18next';
import MessageScreen from "components/SelfCheckin/MessageScreen/MessageScreen"
import ConfirmationMessage from "components/SelfCheckin/ConfirmationMessage/ConfirmationMessage"
import { SelfCheckinStepEnum, PlatformTypes } from "components/shared/enums/global-enums.tsx";
import useStore from 'store/store'

import './Printing.scss'

export default function Printing({airline}){
  const {t} = useTranslation();

  const [redirect, ] = useSelfCheckinNafigation();
  const flightRecords = useStore((state)=> state.flightRecords);
  const selfCheckinChoices = useStore((state)=> state.selfCheckinChoices);
  const storeActions = useStore((state)=> state.actions);
  const touchpointType = storeActions.retrieveItem("touchpoint-type");
  const [message, setMessage] = useState(null);
  const [arrowDirection, setArrowDirection] = useState("");
  const [hasDocuments, setHasDocuments] = useState(true);

  useEffect(()=>{

    function setDirectionOfArrow(direction) {
      if (touchpointType === PlatformTypes.NON_POPPS) setArrowDirection("down");
      else setArrowDirection(direction);
    }

    function lanchBagTagPrint(delai){
      setTimeout(()=> {
        setDirectionOfArrow("left");
        setMessage(t("PRINTING BAGGAGE TAG"))
        } 
        , delai);
    }

    function printing(){
      if (!selfCheckinChoices.find(el => (el.printBoardingPass || el.printBaggageTags))){
        return setHasDocuments(false); 
      }
      storeActions.printElements(flightRecords, selfCheckinChoices, redirect);
      let redAfter = 6000;
      if (selfCheckinChoices.find(el => (el.printBoardingPass))){
        setMessage(t("PRINTING BOARDING PASS"));
        setDirectionOfArrow("right");

        if (selfCheckinChoices.find(el => (el.printBaggageTags))) {
          lanchBagTagPrint(6000);
          redAfter+=6000;
        }
      }else if(selfCheckinChoices.find(el => (el.printBaggageTags))){
        lanchBagTagPrint(0);
      }
      setTimeout(() => redirect(1), redAfter);
    }

    printing();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    
      hasDocuments ?
      (<MessageScreen  airline={airline}  message={message} arrowDirection={arrowDirection} />) :
      (<ConfirmationMessage  airline={airline}  typeFor={SelfCheckinStepEnum.PRINTING} forceFooter={true}/>)  
     
    )
}